module.exports = __webpack_public_path__ + "static/media/MockMac.b7c1bee8.png";